
import { Map } from "../Map";
import {
  applyScaleBarSnapshotToContainer,
  computeScaleBarSnapshot,
} from "./scaleBarCompute";

export default class ScaleBar {
  private _mapObj: Map;
  private _container: HTMLElement;

  constructor(opt: { map: Map }) {
    this._mapObj = opt.map;
    this._container = document.createElement('div');
  }

  onAdd() {
    (<any>this._container).style = 'min-width:300px';

    this._container.innerHTML = `<div class="geobox-gl-scalebar">
      <div class="geobox-gl-scalebar-labels">
        <span data-scalebar="left2"></span>
        <span data-scalebar="left1"></span>
        <span data-scalebar="zero"></span>
        <span data-scalebar="right"></span>
        <span data-scalebar="end"></span>
      </div>
      <div class="geobox-gl-scalebar-bar">
        <div style="border-right: none;" class="geobox-gl-scalebar-segment geobox-gl-scalebar-black"></div>
        <div class="geobox-gl-scalebar-segment geobox-gl-scalebar-white"></div>
        <div style="border-left: none; border-right: none;" class="geobox-gl-scalebar-segment geobox-gl-scalebar-black"></div>
        <div class="geobox-gl-scalebar-segment geobox-gl-scalebar-white"></div>
      </div>
    </div>`;

    setTimeout(() => {
      this._mapObj.on('move', this._onMove);
      this._onMove();
    }, 50);

    return this._container;
  }

  _onMove = () => {
    const snap = computeScaleBarSnapshot(this._mapObj, { maxWidth: 100, unit: 'metric' });
    applyScaleBarSnapshotToContainer(this._container, snap);
  };

  onRemove() {
    try {
      this._mapObj.off('move', this._onMove);
    } catch (error) {
      /* ignore */
    }
    this._container.remove();
  }
}
